"use strict";
/**
 * Created by rouven on 12.04.17.
 */
exports.__esModule = true;
var actionTypes_1 = require("../actions/actionTypes");
/**
 * Handles the SET_USER action.  Changes the user in the app state.
 * @public
 * @param state {object} the current state
 * @param action {object} the dispatched action
 * @returns {{}}
 */
var userReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case actionTypes_1.SET_USER:
            return action.user;
        default:
            return state;
    }
};
exports["default"] = userReducer;
